import React from 'react';
import { isMobile } from 'react-device-detect';

interface TelephoneProps {
    phoneNumber: string | undefined | null;
}

const TelephoneLink: React.SFC<TelephoneProps> = ({phoneNumber}) => {
    if (!phoneNumber) {
        return null;
    }

    if (isMobile) {
        return (
            <a href={`tel:${phoneNumber}`}>
                {phoneNumber}
            </a>
        );
    } else {
        return <span>{phoneNumber}</span>;
    }
};

export { TelephoneLink };
